import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import Axios from "axios";
import "./CreateShipment.css";
import { useLocation } from "react-router-dom";

import swal from "sweetalert";
import alertify from "alertifyjs";

const ShipmentEarlyGenerate = () => {
  const { numRows } = useParams();
  const location = useLocation();

  const shipmentData = location.state?.shipmentData || null;

  const [selectedOrderIds, setSelectedOrderIds] = useState(
    Array.from({ length: parseInt(numRows, 10) }, () => null)
  );

  const handleSelectChange = (index, orderId) => {
    const updatedSelectedOrderIds = [...selectedOrderIds];
    updatedSelectedOrderIds[index] = orderId;
    setSelectedOrderIds(updatedSelectedOrderIds);
  };

  const [boxQuantities, setBoxQuantities] = useState(
    Array.from({ length: parseInt(numRows, 10) }, () => 0)
  );

  const [scannedValues, setScannedValues] = useState(
    Array.from({ length: parseInt(numRows, 10) }, () => [])
  );
  const [checkedRows, setCheckedRows] = useState([]);

  const handleCheckboxChange = (index) => {
    const updatedCheckedRows = [...checkedRows];
    const updatedScannedValues = [...scannedValues];

    if (updatedCheckedRows.includes(index)) {
      const scannedValueIndex = updatedCheckedRows.indexOf(index);
      updatedCheckedRows.splice(scannedValueIndex, 1);
      updatedScannedValues[index] = [];
    } else {
      updatedCheckedRows.push(index);
    }
    setCheckedRows(updatedCheckedRows);
    setScannedValues(updatedScannedValues);
  };

  const handleInputChange = (index, value) => {
    const updatedScannedValues = [...scannedValues];
    updatedScannedValues[index] = value
      .split(",")
      .map((item) => ({ value: item.replace(/\n/g, ",") }));
    setScannedValues(updatedScannedValues);

    const boxQuantity = updatedScannedValues[index].length;
    const updatedBoxQuantities = [...boxQuantities];
    updatedBoxQuantities[index] = boxQuantity;
    setBoxQuantities(updatedBoxQuantities);
  };

  const [totalBoxQuantity, setTotalBoxQuantity] = useState(0);

  useEffect(() => {
    const sumBoxQuantities = boxQuantities.reduce(
      (acc, quantity) => acc + quantity,
      0
    );
    setTotalBoxQuantity(sumBoxQuantities);
  }, [boxQuantities]);

  const handleCreateOutbound = () => {
    if (shipmentData && shipmentData.totalQuantity === totalBoxQuantity) {
      createshipment();
    } else {
      alertify("Total quantity and box quantity do not match.");
    }
  };

  const createshipment = () => {
    const shipmentDataToPost = selectedOrderIds.map((orderId, index) => ({
      orderId,
      scannedValues: scannedValues[index].map((item) =>
        item.value.replace(/\n/g, ",")
      ),
    }));
    Axios.post(
      `${INVENTORY_API_BASE_URL}/createshipment1`,
      shipmentDataToPost
    )
      .then((result) => {
      })
      .catch((error) => {
        alertify("service error");
      });
    swal({
      title: "Outbound Created",
      text: "",
      icon: "success",
    });

    Axios.post(
      `${INVENTORY_API_BASE_URL}/createshipmentDetails`,
      shipmentData
    )
      .then((response) => {
        swal({
          title: "Shipment Created",
          text: "",
          icon: "success",
        });
      })
      .catch((error) => {
        console.error("Error creating shipment:", error);
        swal({
          title: "Error",
          text: "Failed to create shipment",
          icon: "error",
        });
      });
    window.location.reload();
  };

  return (
    <div style={{ marginLeft: "22rem", marginTop: "5rem" }}>
      <h2>Scan Outbound Early Page</h2>
      <Table>
        <thead>
          <tr>
            <th>Box No.</th>
            <th>Select Order No </th>
            <th>Scanned Values</th>
            <th>Book Quantity</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: parseInt(numRows, 10) }).map((_, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <select
                  value={selectedOrderIds[index] || ""}
                  onChange={(e) => handleSelectChange(index, e.target.value)}
                >
                  <option value="">Select an option</option>
                  {shipmentData?.ShipmentDetails?.map((detail) => (
                    <option key={detail.orderId} value={detail.orderId}>
                      {detail.orderId}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={checkedRows.includes(index)}
                  onChange={() => handleCheckboxChange(index)}
                />
                {checkedRows.includes(index) && (
                  <div>
                    <textarea
                      type="text"
                      value={scannedValues[index]
                        .map((item) => item.value.replace(/\n/g, ","))
                        .join(",")}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                    />
                  </div>
                )}
              </td>
              <td>
                <input type="number" value={boxQuantities[index]} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <p>Total Box Quantity: {totalBoxQuantity}</p>
      <button
        onClick={handleCreateOutbound}
        className="outboundbtn"
        // disabled={
      >
        Create Outbound
      </button>
    </div>
  );
};

export default ShipmentEarlyGenerate;
